import React from 'react';
import { Field, reduxForm } from 'redux-form';

import TextField from '../basic/TextField';
import Button from '../basic/Button';

import './Form.css';

const LoginForm = ({ handleSubmit, auth: { error } }) => {
  return (
    <form onSubmit={handleSubmit} className="Form">
      <div className="padding-1em">
        <div><Field name="email" component={TextField} type="text" label="Email" /></div>
        <div><Field name="password" component={TextField} type="password" label="Password" /></div>
        {error && <div className="text-danger"><small>Login error</small></div>}
      </div>
      <div className="Form-buttons">
        <Button primary raised label="Log in" type="submit" />
      </div>
    </form>
  );
};

export default reduxForm({ form: 'login' })(LoginForm);



// WEBPACK FOOTER //
// ./src/components/forms/LoginForm.js